import React, { Component, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import BarLoader from "react-spinners/BarLoader";

import { previewLastMappingExecution, previewPublishedMappingExecution  } from '../../../utils/MappingsAPI';
import { previewLastAnnotatorExecution, previewPublishedAnnotatorExecution  } from '../../../utils/AnnotatorAPI';
import { previewLastClustererExecution, previewPublishedClustererExecution  } from '../../../utils/ClustererAPI';
import { previewLastEmbedderExecution, previewPublishedEmbedderExecution  } from '../../../utils/EmbedderAPI';
import { previewLastPagedAnnotationValidationExecution, previewPublishedPagedAnnotationValidationExecution  } from '../../../utils/PagedAnnotationValidationAPI';
import { previewLastFilterAnnotationValidationExecution, previewPublishedFilterAnnotationValidationExecution  } from '../../../utils/FilterAnnotationValidationAPI';
import { parseResult } from '../../../utils/UIUtils';

function ResultsModal(props) {

  const [shard, setShard] = useState(null)
  const [nextLine, setNextLine] = useState(null)
  const [extraText, setExtraText] = useState('')

  useEffect(() => {
    setShard(props.execution ? props.execution.shard : null)
    setNextLine(props.execution ? props.execution.nextLine : null)
  })

  const updateFromInput = (text) => {
    var p = parseResult(text)
    setExtraText(extraText + p.text)
    setShard(p.shard)
    setNextLine(p.nextLine)
  }

  const handleScroll = (event) => {
    const bottom = event.target.scrollHeight - event.target.scrollTop === event.target.clientHeight;
    if (bottom &&  nextLine &&  nextLine != -1) {
      if (props.execution.type == 'MAPPING') {
        if (props.execution.mode == 'LAST_EXECUTION') {
          previewLastMappingExecution(props.execution.id, props.execution.instanceId, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        } else if (props.execution.mode == 'PUBLISHED_EXECUTION') {
          previewPublishedMappingExecution(props.execution.id, props.execution.instanceId, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        }
      } else if (props.execution.type == 'ANNOTATOR') {
        if (props.execution.mode == 'LAST_EXECUTION') {
          previewLastAnnotatorExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        } else if (props.execution.mode == 'PUBLISHED_EXECUTION') {
          previewPublishedAnnotatorExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        }
      } else if (props.execution.type == 'CLUSTERER') {
        if (props.execution.mode == 'LAST_EXECUTION') {
          previewLastClustererExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        } else if (props.execution.mode == 'PUBLISHED_EXECUTION') {
          previewPublishedClustererExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        }
      } else if (props.execution.type == 'EMBEDDER') {
        if (props.execution.mode == 'LAST_EXECUTION') {
          previewLastEmbedderExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        } else if (props.execution.mode == 'PUBLISHED_EXECUTION') {
          previewPublishedEmbedderExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        }
      } else if (props.execution.type == 'FILTER_VALIDATION') {
        if (props.execution.mode == 'LAST_EXECUTION') {
          previewLastFilterAnnotationValidationExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        } else if (props.execution.mode == 'PUBLISHED_EXECUTION') {
          previewPublishedFilterAnnotationValidationExecution(props.execution.id, shard, nextLine)
            .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
        } else if (props.execution.type == 'PAGED_VALIDATION') {
          if (props.execution.mode == 'LAST_EXECUTION') {
            previewLastPagedAnnotationValidationExecution(props.execution.id, shard, nextLine)
              .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
          } else if (props.execution.mode == 'PUBLISHED_EXECUTION') {
            previewPublishedPagedAnnotationValidationExecution(props.execution.id, shard, nextLine)
              .then(response => { response.text().then(text =>  { updateFromInput(text) }) })
          }
        }
      }
    }
  }

  return (
    <Modal size="xl" show={props.show} onHide={props.onClose} animation={false} backdrop="static">
      <Modal.Header>
        <Modal.Title>Execution result {props.state.loaded && props.execution.file && <span className="result-filename">{props.execution.file}</span>}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="scrollContainer">
      {props.state.loading &&
        <Col className="loader">
          <BarLoader
            css='spinner'
            height={6}
            width={200}
            color='orange'
            loading={true}/>
        </Col>
      }
      {props.state.failed &&
        <Col>
          <span className="error">Loading values failed.</span>
        </Col>
      }
      {props.state.loaded && props.execution && props.execution.text &&
        <code className="scroll" onScroll={handleScroll}>
          <pre>{props.execution.text}
          {extraText}
          </pre>
        </code>}
      </Modal.Body>
      <Modal.Footer>
        <Button primary="secondary" onClick={props.onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ResultsModal;
